import { combineReducers } from 'redux'
import { dashboardReducer as transDashboardReducer } from '../modules/Dashboard/store/reducer'

export const dashboardReducer = combineReducers({
  dashboard: transDashboardReducer
})
